/**
 * Configuration des routes publiques
 */

export const publicPaths = ['/login', '/register', '/forgot-password', '/set-password', '/guides'];
